import React from "react";
import { PreviewWrapper, QrContainer, Wallpaper } from "./QrPreviewStyles";
import QrCodeCore from "../qrCodeCore/QrCodeCore";
import { usePressKit } from "../../../context/PressKitContext";
import { QrPreviewProps } from "../../../types/componentsConstructors";

const QrPreview: React.FC<QrPreviewProps> = ({
  primaryColor,
  backgroundColor,
  wallpaperUrl,
  borderColor,
}) => {
  const { pressKitData } = usePressKit();
  const qrValue = `${window.location.origin}/${pressKitData?.customUrl || ""}`;

  return (
    <PreviewWrapper id="qr-preview">
      {wallpaperUrl && <Wallpaper src={wallpaperUrl} alt="Wallpaper" />}

      <QrContainer $borderColor={borderColor}>
        <QrCodeCore
          value={qrValue}
          fgColor={primaryColor}
          bgColor={backgroundColor}
          size={120}
        />
      </QrContainer>
    </PreviewWrapper>
  );
};

export default QrPreview;
